/**
 * Normalize content for ReactQuill:
 * - If it's HTML: return as-is
 * - If it's HTML-escaped: decode then return
 * - If it's plain text: convert newlines to <p>...</p> so Quill renders line breaks
 *
 * This keeps legacy/dirty data displaying 1:1 in admin editor.
 */
export function normalizeQuillHtml(input?: string | null): string {
  const value = (input ?? '').toString();
  if (!value) return '';

  const trimmed = value.trim();

  // Likely already HTML
  if (/<[a-z][\s\S]*>/i.test(trimmed)) {
    return value;
  }

  // Likely HTML-escaped (e.g. &lt;p&gt;...&lt;/p&gt;)
  if (/&lt;[a-z][\s\S]*&gt;/i.test(trimmed) && typeof document !== 'undefined') {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    const decoded = textarea.value;
    if (/<[a-z][\s\S]*>/i.test(decoded.trim())) {
      return decoded;
    }
  }

  // Plain text: convert line breaks to <p> blocks for Quill
  const lines = value.replace(/\r\n/g, '\n').split('\n');

  return lines
    .map((line) => {
      // escape HTML special chars first
      let text = line
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');

      // preserve indentation for leading spaces/tabs
      text = text
        .replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;')
        .replace(/^ +/g, (m) => '&nbsp;'.repeat(m.length));

      return text ? `<p>${text}</p>` : '<p><br></p>';
    })
    .join('');
}

